import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

import BadgeSelect from '_components/atomic/controls/BadgeSelect';

const BadgeSelectField = ({
  name,
  control,
  rules = {},
  feedback,
  ...restProps
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { ref, ...restField },
        fieldState: { error },
        formState: { isSubmitted },
      }) => (
        <BadgeSelect
          {...restProps}
          {...restField}
          valid={isSubmitted && !error}
          invalid={isSubmitted && error}
          feedback={error?.message || feedback}
        />
      )}
    />
  );
};

BadgeSelectField.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
  rules: PropTypes.object,
  feedback: PropTypes.node,
};

export default BadgeSelectField;
